import { Box, Stack, Typography, Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';
import ArmChart from '../../pages/Ems/Components/ArmChart';
import { assessArmWeakness } from './ArmWeaknessAssessment';
import { ResultRow } from '../../pages/Ems/Components/ResultRow';

const pitchDomain = [-2, 2];
export function ArmPitch({ armsPitchData, title }) {
  const { t } = useTranslation();

  const formatData = (data) => {
    return data.map((value, index) => ({ timestamp: index, val: value }));
  };

  const calcResult = () => {
    return assessArmWeakness(armsPitchData);
  };

  return (
    <Grid xs={6} item sx={{ marginTop: '16px' }}>
      <Typography sx={{ textAlign: 'Center' }} variant="h5">
        {title}
      </Typography>
      {armsPitchData?.length > 0 && (
        <Stack>
          <ArmChart domain={pitchDomain} width={490} data={formatData(armsPitchData)} x_label="timestamp" y_label="val" />
        </Stack>
      )}
      <Box sx={{ paddingLeft: '50px', paddingRight: '5px' }}>
        <ResultRow title="Arm Weakness" value={t(calcResult())} />
      </Box>
    </Grid>
  );
}
